import HrCalendarPg from "../HR/HrCalendarPg";

function CalendarSection() {
  return <HrCalendarPg readOnly />;
}

export default CalendarSection;
